import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class SellingCompanyReferenceService extends BaseReferenceService {
  constructor() {
    super('SellingCompanyReference');
  }
}
